var earthRadiusMeters=6367460.0;
var metersPerDegree=2.0*Math.PI*earthRadiusMeters/360.0;
var meters2PerHectare=10000.0;
var metersPerKm=1000.0;
var feetPerMeter=3.2808399;
var feetPerMile=5280.0;
var acresPerMile2=640;
var radiansPerDegree=Math.PI/180.0;
function PlanarPolygonAreaMeters2(points)
{
	var a=0.0;
	for(var i=0;i<points.length;++i)
	{
		var j=(i+1)%points.length;
		var xi=points[i].lng()*metersPerDegree*Math.cos(points[i].lat()*radiansPerDegree);
		var yi=points[i].lat()*metersPerDegree;
		var xj=points[j].lng()*metersPerDegree*Math.cos(points[j].lat()*radiansPerDegree);
		var yj=points[j].lat()*metersPerDegree;
		a+=xi*yj-xj*yi;
	}
	return Math.abs(a/2.0);
}
function AreasFeet(areaMeters2)
{
	var areaHectares=areaMeters2/meters2PerHectare;
	var areaKm2=areaMeters2/metersPerKm/metersPerKm;
	var areaFeet2=areaMeters2*feetPerMeter*feetPerMeter;
	var areaMiles2=areaFeet2/feetPerMile/feetPerMile;
	var areaAcres=areaMiles2*acresPerMile2;
	return areaFeet2;
}